import "./ClinicalRecordPage.scss";
import PatientClinicalRecordCard from "../../Components/PatientClinicalRecordCard/PatientClinicalRecordCard";
import { useEffect, useState } from "react";
import { IPatient } from "../../Models/IPatient";
import ApiService from "../../Services/ApiService";
import { IAPIResponse } from "../../Services/AjaxService";
import Loadable from "../../Components/Loadable/Loadable";
import DataTable from "../../Components/DataTable/DataTable";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { DATA } from "../../Utils/Comuni";
import PhiscalCodeUtil from "../../Utils/PhiscalCode";
import FileMetaHandler, {
  IFileMetaData,
} from "../../Components/FileMetaHandler/FileMetaHandler";
import CustomCommandBar from "../../Components/CustomCommandBar/CustomCommandBar";
import NavigationMenu from "../../Components/NavigationMenu/NavigationMenu";

const ClinicalRecordPage = () => {
  const [data, setData] = useState<any>({});

  const [loading, setLoading] = useState<boolean>(false);
  const [patients, setPatients] = useState<IPatient[]>([]);
  const [patient, setPatient] = useState<IPatient | undefined>();
  const [files, setFiles] = useState<IFileMetaData[]>([]);

  const loadPatients = () => {
    setLoading(true);
    ApiService.PatientController.GetPatients((response: IAPIResponse) => {
      if (response.error === null) {
        setPatients(response.parsed);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    loadPatients();
  }, []);

  const saveMeta = () => {
    if (patient) {
      data.files = files;
      setLoading(true);
      ApiService.PatientController.UpdatePatientMeta(
        patient.id,
        data,
        (response: IAPIResponse) => {
          if (response.error === null) {
            loadPatients();
            setPatient(undefined);
          }
          setLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    if (
      data.nome &&
      data.cognome &&
      data.nascita &&
      data.sesso &&
      data.comune
    ) {
      let cf = PhiscalCodeUtil.ComputePhiscalCode(
        data.nome,
        data.cognome,
        data.nascita,
        data.sesso,
        data.comune
      );
      let data_ = { ...data };
      data_["cf"] = cf;
      setData(data_);
    }
  }, [data]);

  const getPatientCardInputs = () => {
    return [
      {
        name: "nome",
        label: "Nome",
        type: "text",
      },
      {
        name: "cognome",
        label: "Cognome",
        type: "text",
      },
      {
        name: "nascita",
        label: "Data di nascita",
        type: "date",
      },
      {
        name: "sesso",
        label: "Sesso",
        type: "select",
        options: [
          { key: "M", text: "Uomo" },
          { key: "F", text: "Donna" },
        ],
      },
      {
        name: "comune",
        label: "Comune",
        type: "combo",
        options: DATA.map((x: any) => {
          return {
            key: x.codiceCatastale,
            text: x.nome,
          };
        }),
      },
      {
        name: "cf",
        label: "Codice fiscale",
        type: "auto",
      },
      {
        name: "note",
        label: "Note",
        typ: "text",
      },
    ];
  };

  return (
    <div className="fade-in-whole-page">
      <CustomCommandBar
        specials={[
          <div className="command-bar-title">Scheda ospite</div>,
          <NavigationMenu />,
        ]}
        buttons={[]}
      />
      {patient === undefined && (
        <Loadable
          isLoading={loading}
          content={
            <DataTable
              extraInnerProps={{
                allowFilter: true,
              }}
              rowData={(patients ?? []).sort((a: IPatient, b: IPatient) => {
                return a.identifier.localeCompare(b.identifier);
              })}
              columns={[
                {
                  name: "Scheda ospite",
                  fieldName: "_",
                  dataType: "string",
                  size: "small",
                  onRender: (data: any) => {
                    return (
                      <PrimaryButton
                        onClick={() => {
                          let activePatient = JSON.parse(JSON.stringify(data));
                          let parsedPatientCard =
                            activePatient.patientCard ?? "{}";
                          let parsedParsedPatientCard =
                            JSON.parse(parsedPatientCard);
                          setPatient(activePatient);
                          setData(parsedParsedPatientCard);
                          setFiles(parsedParsedPatientCard.files ?? []);
                        }}
                        text={"Apri"}
                      />
                    );
                  },
                },
                {
                  name: "Ospite",
                  fieldName: "identifier",
                  dataType: "string",
                  size: "medium",
                },
                {
                  name: "Ultima Modifica",
                  fieldName: "updatedAt",
                  dataType: "date",
                  size: "medium",
                },
                {
                  name: "Data Creazione",
                  fieldName: "createdAt",
                  dataType: "date",
                  size: "medium",
                },
              ]}
            />
          }
        />
      )}

      {patient && (
        <div style={{ padding: "1em" }}>
          <DefaultButton
            style={{ marginRight: "1em" }}
            disabled={loading}
            text={"Indietro"}
            iconProps={{ iconName: "Back" }}
            onClick={() => {
              setPatient(undefined);
            }}
          />

          <PrimaryButton
            disabled={loading}
            text={"Salva"}
            iconProps={{ iconName: "Save" }}
            onClick={saveMeta}
          />

          <Loadable
            isLoading={loading}
            content={
              <div>
                <PatientClinicalRecordCard
                  sectionFields={getPatientCardInputs() as any}
                  sectionType={"default"}
                  sectionTitle={"Dati Anagrafici"}
                  emit={setData}
                  sourceData={data}
                />
                <hr />
                <FileMetaHandler rawFiles={files} emitFiles={setFiles} />
              </div>
            }
          />
        </div>
      )}
    </div>
  );
};

export default ClinicalRecordPage;
